import React, { useEffect, useState, useRef } from 'react';

const useTick = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const intId = setInterval(() => {
      setCount((c) => c + 1);
    }, 1000);

    return () => clearInterval(intId);
  }, []);

  return [count];
};

const useCountdown = (elapsed) => {
  const [endTime, setEndTime] = useState(0);
  const [tick] = useTick();

  let timer = null;
  if (endTime > tick) {
    timer = endTime - tick;
  } else if (endTime !== 0) {
    timer = 0;
  }

  const startTimer = () => {
    if (endTime === 0) {
      setEndTime(tick + elapsed);
    }
  };

  const endTimer = () => {
    setEndTime(0);
  };

  return [timer, startTimer, endTimer];
};

const AutoReloadIFrame = ({
  src,
  title,
  style,
  enabled = false,
  timeSeconds = 60,
}) => {
  const [frameKey, setFrameKey] = useState('auto_reload_frame_0_id');
  const [timer, startTimer, endTimer] = useCountdown(timeSeconds);
  const iframeRef = useRef(null);

  useEffect(() => {
    if (enabled && timer === 0) {
      try {
        // Check if iframe is actually in the document before refreshing
        if (
          iframeRef.current &&
          document.contains(iframeRef.current)
        ) {
          console.log(
            '[AutoReloadIFrame] Refreshing iframe with src:',
            src,
          );
          endTimer();
          const x = Math.floor(Math.random() * 10000);
          setFrameKey(`auto_reload_frame_${x}_id`);
        } else {
          console.log(
            '[AutoReloadIFrame] Iframe not in DOM, skipping refresh',
          );
          endTimer(); // Reset the timer anyway to avoid looping
        }
      } catch (error) {
        console.error(
          '[AutoReloadIFrame] Error refreshing iframe:',
          error,
        );
        endTimer(); // Reset timer to prevent getting stuck
      }
    }
  }, [timer, enabled, endTimer, src]);

  const handleOnLoad = () => {
    if (enabled) {
      startTimer();
    }
  };

  return (
    <iframe
      ref={iframeRef}
      key={frameKey}
      src={src}
      title={title}
      style={style}
      onLoad={handleOnLoad}
    />
  );
};

export default AutoReloadIFrame;
